// @flow

import { observer } from "mobx-react";
import React from "react";

import { REACTIONS } from "app/models/TimelineItem";

import "./TimelineCardReaction.scss";

type Props = {
    userReaction: ?number,
    type: number,
    total: number,
    onReact: Function
};

@observer
export default class TimelineCardReaction extends React.Component<Props> {
    render() {
        const type = this.props.type;
        const total = this.props.total;

        let classes = ["TimelineCardReaction"];
        if (type === this.props.userReaction) {
            classes.push("TimelineCardReaction--selected");
        }

        const thumbsClasses = type === REACTIONS.LIKE ? "up" : "down";

        return (
            <button
                className={classes.join(" ")}
                onClick={this.props.onReact.bind(this, type)}
            >
                <i
                    className={
                        "TimelineCardReaction__icon fa fa-thumbs-" +
                        thumbsClasses
                    }
                />
                <span className="TimelineCardReaction__count">
                    {total || 0}
                </span>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCardReaction/TimelineCardReaction.js